export const buildQueryParams = (args) => {
  const params = [];

  const processValue = (value) => {
    return encodeURIComponent(value);
  }

  for (const key in args) {
    if(key === "collectionId" || key == undefined || key == "undefined") continue;

    if(Array.isArray(args[key]) && args[key].length == 1){
      params.push(`${key}=${processValue(args[key][0])}`);
    }else if(Array.isArray(args[key])){
      args[key].forEach(item => {
        params.push(`${key}[]=${processValue(item)}`);
      })
    }else{
      params.push(`${key}=${processValue(args[key])}`);
    }
  }

  const paramsString = params.join("&");

  return paramsString;
}